import React, { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import TopNav from '@/components/TopNav';
import LicenseGate from '@/components/LicenseGate';
import Home from '@/pages/Home';
import Studio from '@/pages/Studio';
import Result from '@/pages/Result';
import Presets from '@/pages/Presets';
import Projects from '@/pages/Projects';
import Admin from '@/pages/Admin';
import { StudioProvider } from '@/store/StudioStore';
import { GOOGLE_FONT_URL } from '@/data/fontMap';

function App() {
  useEffect(() => {
    document.documentElement.classList.add('dark');
    if (!document.getElementById('te-google-fonts')) {
      const l = document.createElement('link');
      l.id = 'te-google-fonts'; l.rel = 'stylesheet'; l.href = GOOGLE_FONT_URL;
      document.head.appendChild(l);
    }
  }, []);
  return (
    <div className="App noise min-h-screen overflow-x-hidden">
      <BrowserRouter>
        {/* Owner Admin has its own password gate and lives outside the license flow. */}
        <Routes>
          <Route path="/admin" element={<AdminShell />} />
          <Route path="/*" element={<LicensedShell />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

function LicensedShell() {
  return (
    <LicenseGate>
      <StudioProvider>
        <TopNav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/studio" element={<Studio />} />
          <Route path="/result" element={<Result />} />
          <Route path="/presets" element={<Presets />} />
          <Route path="/projects" element={<Projects />} />
        </Routes>
      </StudioProvider>
    </LicenseGate>
  );
}

function AdminShell() {
  // StudioProvider is needed here because <TopNav> uses <SmartSearch> which
  // reads the Studio store. Wrapping it here does not touch any studio UI.
  return (
    <StudioProvider>
      <TopNav />
      <Admin />
    </StudioProvider>
  );
}

export default App;
